const crops: any = {
    crops: {
        "1": "Water melon",
        "2": "Pumpkin summer squash",
        "3": "Zucchini",
        "4": "Sugarcane",
        "5": "Cucumber pickling",
        "6": "Apples",
        "7": "Celery",
        "8": "Apricots",
        "9": "Celery green  fall",
        "10": "Chives - 1sr yr",
        "11": "Chives - 2nd yr",
        "12": "Carrots washed",
        "13": "Sweet potatoes",
        "14": "Corn (silage, 67% water)",
        "15": "Peaches",
        "16": "Potatoes",
        "17": "Onion spring",
        "18": "Garlic",
        "19": "Kale, curly kale",
        "20": "StrawBerries",
        "21": "Beetroot",
        "22": "Broccoli",
        "23": "Brussels sprouts",
        "24": "Celery -blanched fall",
        "25": "Sugarbeets",
        "26": "Carrot winter",
        "27": "Tomatoes",
        "28": "Onion winter",
        "29": "Grapes (table)",
        "30": "Lettuce - headed summer",
        "31": "Parsley",
        "32": "Lettuce - oakleaf summer",
        "33": "Lettuce oakleaf",
        "34": "Topinambur Jerusalem artichoke",
        "35": "Prunes",
        "36": "Cantaloupe",
        "37": "Oil palm",
        "38": "Lettuce",
        "39": "Kiwi",
        "40": "Cabagge red",
        "41": "Pears",
        "42": "Banana",
        "43": "Endive, escarole - summer",
        "44": "Endive, escarole - baby",
        "45": "Endive curly-leaved",
        "46": "Cabbage - common storage",
        "47": "Leek summer",
        "48": "Leek autumn winter",
        "49": "Strawberry perpetual fruiting",
        "50": "Papaya",
        "51": "Spinach",
        "52": "Tomato processing",
        "53": "Squash",
        "54": "Chicory",
        "55": "Cabbage",
        "56": "Eggplant",
        "57": "Cabbage spring",
        "58": "Cabbage savoy",
        "59": "Cabbage green savoy",
        "60": "Commom Bean",
        "61": "Oranges",
        "62": "Shallot red",
        "63": "Melon",
        "64": "Tobacco (flue)",
        "65": "Tobacco (burley)",
        "66": "Coffee",
        "67": "Barley (spring)",
        "68": "Wheat: 10% protein",
        "69": "Wheat: 12% protein",
        "70": "Wheat: 14% protein",
        "71": "Corn (grain)",
        "72": "Sunflower",
        "73": "Rice",
        "74": "Sorghum (grain)",
    },
};

export default crops;
